export enum ConverterOperatingModeEnum {
  /** По графику */
  SCHEDULE = 'SCHEDULE',
  /** Ручной режим */
  HAND = 'HAND',
}